export default {
  SET_NAV_KEY: "SET_NAV_KEY",
  GET_ALERT_NOTIFICATION_BY_USERID: "GET_ALERT_NOTIFICATION_BY_USERID",

};
